<template>
    <div class="footer">
        <div class="content">
            <span>备案号 01</span>
            <span>© faka源头一手批发商城 - 保留所有解释权。</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterPage',
    props: {
        msg: String
    }
}
</script>

<style scoped lang="less">
.footer {
    width: 100%;
    height: 48px;
    border-top: 1px solid #EDF2FA;
    display: flex;
    justify-content: center;
    background-color: #fff;
}

.content {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
</style>
